import { createContext, useContext, useState, ReactNode } from "react";

interface FocusContextType {
    focusedIndex: number | null;
    setFocusedIndex: (index: number | null) => void;
}

const FocusContext = createContext<FocusContextType | undefined>(undefined);

interface FocusProviderProps {
    children: ReactNode;
}

export const FocusProvider = ({ children }: FocusProviderProps) => {
    const [focusedIndex, setFocusedIndex] = useState<number | null>(null);

    return <FocusContext.Provider value={{ focusedIndex, setFocusedIndex }}>{children}</FocusContext.Provider>;
};

// Hook to access the FocusContext easily
export const useFocus = (): FocusContextType => {
    const context = useContext(FocusContext);
    if (context === undefined) {
        throw new Error("useFocus must be used within a FocusProvider");
    }
    return context;
};
